/** HTTP status the data-ingestion API client attaches to the errors it throws. */
export function getApiErrorStatus(error: unknown): number | undefined {
  if (typeof error !== 'object' || error === null || !('status' in error)) {
    return undefined
  }

  const { status } = error as { status: unknown }

  return typeof status === 'number' ? status : undefined
}

/** TanStack Query `retry` policy: one retry for network and 5xx errors, none for 4xx. */
export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  const status = getApiErrorStatus(error)

  return failureCount < 1 && (status === undefined || status >= 500)
}
